@if (access.classicVisible()) {
  <hd-iching-consult [initial]="initial()" (initialApplied)="clearQueryParams()" />
} @else if (access.featureGranted()) {
  <div class="iching-page__gate">
    <p class="iching-page__gate-text">{{ t('humanDesign.iching.page.enableInSettings') }}</p>
    <button type="button" class="iching-page__enable" data-test-id="iching-enable" (click)="enable()">
      {{ t('humanDesign.iching.page.enableNow') }}
    </button>
  </div>
} @else {
  <div class="iching-page__gate">{{ t('humanDesign.iching.page.notAvailable') }}</div>
}
